<template>
  <div>
    <b-modal
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      title="Languages"
      :static="true"
      :lazy="true"
      hide-footer
    >
      <div class="modal-body">
        <div class="list-group list-group-flush">
          <div class="list-group-item">
            <div class="justify-content-between row">
              <div class="col-md-1">Show</div>
              <div class="col-md-3">Translations</div>
            </div>
          </div>

          <div v-for="language in sortedTranslations" :key="language.id" class="list-group-item">
            <form class="">
              <div class="align-items-center row">
                <div class="col-md-1">
                  <button @click="toggleLanguageVisibility(language)" :disabled="isDisabled(language.code)" type="button" class="btn btn-light btn-sm">
                    <i v-if="isHidden(language)" class="fa fa-ban"></i>
                    <i v-else class="fa fa-check"></i>
                  </button>
                </div>
                <div class="col-md-3">
                  <input v-model="language.name" :readonly="isDisabled(language.code)" name="name" type="text" class="form-control form-control-sm">
                </div>
                <div class="col-md-2">
                  <input v-model="language.code" :readonly="isDisabled(language.code)" name="code" type="text" class="form-control form-control-sm">
                </div>
                <div class="col-md-3">
                  <div class="d-flex">
                    <button @click="saveLanguage(language)" :disabled="isDisabled(language.code)" type="button" class="ml-2 btn btn-success btn-sm">
                      <i class="fa fa-save"></i>
                    </button>
                    <div class="control-target">

                      <button :id="'remove-language-btn-' + language.id" :disabled="isDisabled(language.code)" type="button" class="ml-2 btn btn-danger btn-sm">
                        <i class="fa fa-times"></i>
                      </button>
                      <b-popover :ref="'removeLanguagePopover' +  language.id" placement="right" boundary="window"
                                 :target="'remove-language-btn-' + language.id"
                                 :title="'Delete language?'"
                      >
                        <div class="d-flex justify-content-end m-0 form-group">
                          <button type="button" @click="$refs['removeLanguagePopover' + language.id][0].$emit('close');" class="btn btn-light btn-sm">Cancel</button>
                          <button type="button" @click="removeLanguage(language)"  class="ml-2 btn btn-danger btn-sm">Delete</button>
                        </div>
                      </b-popover>

                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <b-progress :max="stats.totalTerms">
                    <b-progress-bar :value="stats.counts[language.id]" :label="`${((stats.counts[language.id] / stats.totalTerms) * 100).toFixed(0)}%`"></b-progress-bar>
                  </b-progress>
                </div>
              </div>
              <div class="d-flex invalid-feedback row">
                <div class="col-md-1"></div>
                <div class="col"></div>
              </div>
            </form>
          </div>

          <div class="list-group-item">
            <form class="">
              <div class="align-items-center row">
                <div class="col-md-1"></div>
                <div class="col-md-3">
                  <input v-model="createLanguageForm.name" name="name" type="text" class="form-control form-control-sm">
                </div>
                <div class="col-md-2">
                  <input v-model="createLanguageForm.code" name="code" type="text" class="form-control form-control-sm">
                </div>
                <div class="col-md-3">
                  <div class="d-flex">
                    <button @click="createLanguage()" type="button" class="ml-2 btn btn-success btn-sm">
                      <i class="fa fa-save"></i>
                    </button>
                    <div class="control-target">
                    </div>
                  </div>
                </div>
                <div class="col-md-3"></div>
              </div>
              <div class="d-flex invalid-feedback row">
                <div class="col-md-1"></div>
                <div class="col"></div>
              </div>
            </form>
          </div>



        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      createLanguageForm: {name: '', code: ''},
      modalShow: false,
      stats: {
        languages: {},
        totalTerms: 0,
        counts: {}
      }
    }
  },
  props: [
    'languages', 'disabledCodes', 'terms', 'translations', 'hiddenCodes'
  ],
  watch: {
    translations: function (newVal) {
      newVal.forEach((trans) => {
        if (!trans.text) {
          return;
        }
        if (!this.stats.counts[trans.languageId]) {
          this.stats.counts[trans.languageId] = 0;
        }
          this.stats.counts[trans.languageId]++;
      })
    },
    terms: function (newVal) {
      this.stats.totalTerms = newVal.length;
    },
    languages: function(newVal) {
      this.stats.languages = {};
      newVal.forEach((lang) => {
        this.stats.languages[lang.id] = Vue.util.extend({}, lang);
      })
    }
  },
  methods: {
    createLanguage() {
      this
        .$http({
          url: '/api/v1/localization/languages',
          method: 'POST',
          data: {
            name: this.createLanguageForm.name,
            code: this.createLanguageForm.code
          }
        })
        .then((resp) => {
          this.createLanguageForm.name = '';
          this.createLanguageForm.code = '';
          this.$emit('languageCreated', resp.data);
        })
        .catch((err) => {
          console.log(err);
        })
    },
    isHidden(lang) {
      return this.hiddenCodes.indexOf(lang.code) >= 0;
    },
    toggleLanguageVisibility(lang) {
      if (!this.isHidden(lang)) {
        this.$emit('hideLanguage', lang);
      } else {
        this.$emit('showLanguage', lang);
      }
    },
    removeLanguage(lang) {
      this
        .$http({
          url: '/api/v1/localization/languages/' + lang.id,
          method: 'DELETE',
        })
        .then(() => {
          this.$refs['removeLanguagePopover' + lang.id][0].$emit('close');
          this.$emit('languageRemoved', lang.id);
        })
        .catch((err) => {
          console.log(err);
        })
    },
    saveLanguage(lang) {
      this
        .$http({
          url: '/api/v1/localization/languages/' + lang.id,
          method: 'PUT',
          data: {
            code: lang.code,
            name: lang.name
          }
        })
        .then(() => {
          this.$emit('languageChanged', lang);
        })
        .catch((err) => {
          console.log(err);
        })

    },
    isDisabled(code) {
        return this.disabledCodes.indexOf(code) >= 0;
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
  },
  computed: {
    sortedTranslations: function () {
      return Object.values(this.stats.languages).sort((a, b) => {
        if (this.isDisabled(a.code) === this.isDisabled(b.code)) {
            return a.name > b.name ? 1 : -1;
        }
        return this.isDisabled(a.code) > this.isDisabled(b.code) ? -1 : 1
      })
    }
  },
}
</script>
